/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CommerceDeactivationSpec { 
    /**
     * List of Deployment Ids to work on in a Service
     */
    deployment_ids: Array<string>;
}

